import PropTypes from "prop-types";
import { Popup } from "semantic-ui-react";
import { Right, Value } from "./styles";

export const RightWithHover = ({ content, theme, width, category }) => {
  return (
    <Popup
      basic
      content={`${content} hours ${category}`}
      trigger={
        <Right width={width} style={theme}>
          <Value>{content}</Value>
        </Right>
      }
    />
  );
};

RightWithHover.propTypes = {
  content: PropTypes.string.isRequired,
  theme: PropTypes.shape({}).isRequired,
  width: PropTypes.PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
};
